export var JobState;
(function (JobState) {
    JobState[JobState["Zombie"] = 0] = "Zombie";
    JobState[JobState["Waiting"] = 1] = "Waiting";
    JobState[JobState["Queued"] = 2] = "Queued";
    JobState[JobState["Running"] = 3] = "Running";
    JobState[JobState["Erroneous"] = 4] = "Erroneous";
    JobState[JobState["Completed"] = 5] = "Completed";
})(JobState || (JobState = {}));
;
